module.exports = __webpack_public_path__ + "static/img/intel_property1.36ec38c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intel_property1.png
// module id = NLUU
// module chunks = 1